import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { registerAd } from 'ducks/ads';
import { isSmallViewPort } from 'utils/viewports';

export class Overlay2 extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    adUnitLevel3: PropTypes.string.isRequired,
    reset: PropTypes.bool.isRequired,
    registerAd: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.config = {};
  }

  getConfig() {
    const { id, adUnitLevel3 } = this.props;
    const pos = isSmallViewPort() ? 'overlay-m2' : 'overlay2';
    const adUnitLevel1 = isSmallViewPort() ? 'whatcar.m' : 'whatcar';
    const adUnit = ['8527', adUnitLevel1, 'valuation', adUnitLevel3];

    this.config = {
      id,
      adUnit,
      targeting: {
        pos,
        n_sec3: adUnitLevel3
      },
      sizes: [[1, 3]]
    };

    return this.config;
  }

  componentDidUpdate() {
    const { registerAd, reset } = this.props;
    const config = this.getConfig();

    if (!reset) {
      registerAd(config);
    }
  }

  componentDidMount() {
    const { registerAd } = this.props;
    const config = this.getConfig();

    registerAd(config);
  }

  render() {
    const { id, reset } = this.props;

    return <React.Fragment>{reset ? null : <div id={id} />}</React.Fragment>;
  }
}

const mapStateToProps = state => ({
  reset: state.ads.reset
});

const mapDispatchToProps = {
  registerAd
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Overlay2);



// WEBPACK FOOTER //
// ./src/components/Ads/Overlay2.js